import {
  DatePicker,
  Form,
  Input,
  Select,
  InputNumber,
  Button,
  message,
  Flex,
} from 'antd';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { getServiceUrl } from '../../config';
import { useNavigate } from 'react-router-dom';

const BASE_URL = getServiceUrl();

const PersonalInfoRevamp = (props) => {
  const [isPending, setIsPending] = useState(true);
  const genderData = useRef();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  function onFormFinish(formDetails) {
    setIsPending(true);
    (async () => {
      try {
        const config = {
          headers: {
            rdxtoken: localStorage.getItem('tokenId'),
          },
        };
        const response = await axios.post(
          BASE_URL + 'patient/insertpatient',
          formDetails,
          config,
        );
        message.success({
          duration: 5, // duration in seconds
          content: 'The patient was inserted',
        });
        navigate(response.data.patient.patientguid);
        props.setCurrStep((prevValue) => prevValue + 1);
      } catch (error) {
        message.error({
          duration: 5, // duration in seconds
          content: 'Failed to insert the patient',
        });
        console.error('Error inserting patient!', error);
      }
    })();
  }

  useEffect(() => {
    // fetch master data.
    (async () => {
      try {
        const config = {
          headers: {
            rdxtoken: localStorage.getItem('tokenId'),
            keys: JSON.stringify(['gender']),
          },
        };
        const response = await axios.get(
          BASE_URL + 'master/globalmasterdetails',
          config,
        );
        genderData.current = response.data;
        setIsPending(false);
      } catch (error) {
        console.log('Error fetching master data:', error);
      }
    })();
  }, []);

  const validateTime = 500;

  if (isPending) {
    return <div>Loading...</div>;
  }

  return (
    <div className="m-auto w-2/3">
      <Form layout="vertical" form={form} onFinish={onFormFinish} size="middle">
        <Form.Item
          name="firstname"
          label="First Name"
          layout="vertical"
          hasFeedback
          validateDebounce={validateTime}
          rules={[
            {
              required: true,
              message: 'First name required',
            },
          ]}
        >
          <Input placeholder="e.g. Raj"></Input>
        </Form.Item>

        <Form.Item
          name="lastname"
          label="Last Name"
          layout="vertical"
          hasFeedback
          validateDebounce={validateTime}
          rules={[
            {
              required: true,
              message: 'Last name required',
            },
          ]}
        >
          <Input placeholder="e.g. Sharma"></Input>
        </Form.Item>

        <Form.Item
          name="dob"
          label="Date of Birth"
          layout="vertical"
          hasFeedback
          validateDebounce={validateTime}
          rules={[
            {
              required: true,
              message: 'Please enter date of birth',
            },
            {
              validator: function (_, value) {
                const today = new Date();
                const birthDate = new Date(value);
                if (birthDate.valueOf() > today.valueOf()) {
                  return Promise.reject('Date must not be in future');
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <DatePicker
            needConfirm
            className="w-full"
            placeholder="Date of Birth"
          ></DatePicker>
        </Form.Item>

        <Form.Item
          name="gender"
          label="Gender"
          layout="vertical"
          hasFeedback
          validateDebounce={validateTime}
          rules={[
            {
              required: true,
              message: 'Please select a gender',
            },
          ]}
        >
          <Select
            placeholder="e.g. Female"
            options={[
              { value: genderData.current[0].data[0].Id, label: 'Male' },
              { value: genderData.current[0].data[1].Id, label: 'Female' },
              { value: genderData.current[0].data[2].Id, label: 'Other' },
            ]}
          ></Select>
        </Form.Item>

        <Flex gap={30}>
          <Form.Item name="height" label="Height" layout="vertical">
            <InputNumber addonAfter="cm."></InputNumber>
          </Form.Item>

          <Form.Item name="weight" label="Weight" layout="vertical">
            <InputNumber addonAfter="kg."></InputNumber>
          </Form.Item>
        </Flex>

        <Form.Item>
          <Button
            className="w-full"
            type="primary"
            htmlType="submit"
            loading={isPending}
          >
            Create Patient
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default PersonalInfoRevamp;
